
		require("../components/lazysizes/lazysizes.min.js")
		var jQuery = $ = require('../components/jquery/jquery.js');
		window.jquery = jQuery;
    	window.jQuery = jQuery;
    	window.$ = $;
		require("../components/popper/popper.min.js")
		require("../components/flickity/flickity.min.js")
		require("../components/bootstrap-4.3.1/dist/js/bootstrap.min.js")
		require("../components/jquery.easing-master/jquery.easing.min.js")
		const is = require('../components/is.js/is.min.js');
		require("../components/jquery.appear/jquery.appear.js")
		if (document.querySelector('.google-map')) {
			console.log('google-map');
			//require("../components/infobox/infobox.js")
		} else {
			console.log('no google-map');
		}
		require("./donation.js")
		var Cookies = require("../components/js.cookie/js.cookie.js")

	/* variables */

		var windowWidthForResize, resizeTimer, layoutIs ;

		var scrollTimeDefault 		= 	1000 ;

		windowWidthForResize        =   $(window).width() ;

	/* variables */



	/* codekit-prepends */

		// @codekit-prepend "../components/lazysizes/lazysizes.min.js"
		// @codekit-prepend "../components/jquery/jquery.js"
		// @codekit-prepend "../components/popper/popper.min.js"
		// @codekit-prepend "../components/flickity/flickity.min.js"
		// @codekit-prepend "../components/bootstrap-4.3.1/dist/js/bootstrap.min.js"
		// @codekit-prepend "../components/jquery.easing-master/jquery.easing.min.js"
		// @codekit-prepend "../components/is.js/is.min.js"
		// @codekit-prepend "../components/jquery.appear/jquery.appear.js"
		// @codekit-prepend "../components/infobox/infobox.js"
		// @codekit-prepend "../components/js.cookie/js.cookie.js"

		// @codekit-prepend "../js/functions.js"

	/* codekit-prepends */

	/* google maps */

		/*
		*  addMarker
		*
		*  This function will add a marker to the selected Google Map
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	$marker (jQuery element)
		*  @param	map (Google Map object)
		*  @return	n/a
		*/

			var currentInfoBox = false ;

			function addMarker($marker, map) {

				// var
					var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
					/*console.log($marker);
					console.log(latlng);*/


				// Add markers to the map

				// Marker sizes are expressed as a Size of X,Y
				// where the origin of the image (0,0) is located
				// in the top left of the image.

				// Origins, anchor positions and coordinates of the marker
				// increase in the X direction to the right and in
				// the Y direction down.
						var image_default = {
							url: $('body').data('wptheme') + '/images/mapsicon.svg',
							size: new google.maps.Size(26, 26),
							origin: new google.maps.Point(0,0),
							anchor: new google.maps.Point(13, 13),
							scaledSize: new google.maps.Size(26, 26)
						};
						/*var image_hover = {
							url: $('body').data('wptheme') + '/images/mapsicon_hover.png',
							size: new google.maps.Size(158, 158),
							origin: new google.maps.Point(0,0),
							anchor: new google.maps.Point(79, 79),
							scaledSize: new google.maps.Size(158, 158)
						};*/


				// create marker
					var marker = new google.maps.Marker({
						position		: 	latlng,
						map				: 	map,
						icon 			: 	image_default,
						defaultIcon 	: 	image_default,
						//opacity 		: 	0.5,
						//optimized 	: 	false
					});
					marker.addListener('mouseover', function() {

						if(map.getZoom() > 12) {

							// Loop all Markes, close their infoBoxes and reset the Icon
								for(var i = 0; i < map.markers.length; i++){
									
									map.markers[i].setIcon(map.markers[i].defaultIcon);
									//map.markers[i].infoBox.close(map,map.markers[i]);

								}

							//infoBox.open(map, marker);
							//currentInfoBox = infoBox ;

						}

					});
					marker.addListener('click', function() {

						// Loop all Markes, close their infoBoxes and reset the Icon
							for(var i = 0; i < map.markers.length; i++){
								
								map.markers[i].setIcon(map.markers[i].defaultIcon);
								//map.markers[i].infoBox.close(map,map.markers[i]);

							}

						//marker.setIcon(image_hover);
						//infoBox.open(map, marker);
						//currentInfoBox = infoBox ;
					});
					marker.addListener('mouseout', function() {
						setTimeout(function() {
							//marker.setIcon(image_default);
							//infoBox.close(map,marker);
						}, 2222);
					});


				// add to array
					map.markers.push( marker );


				// if marker contains HTML, add it to an infoBox
					if($marker.html()) {

						// infoBox
							// http://google-maps-utility-library-v3.googlecode.com/svn/tags/infobox/1.1.5/docs/reference.html
		
						//var infoBoxContent = document.createElement("div");
						//infoBoxContent.innerHTML =  $marker.html();

						var infoBoxOptions = {
							content: $marker.find('.marker-content').html(),
							boxClass: 'google-maps-info-box',
							maxWidth: 0,
							disableAutoPan: false,
							pixelOffset: new google.maps.Size(-79, -79), // 150 + 4 (8) BORDER
							zIndex: 3,
							closeBoxURL: "",
							infoBoxClearance: new google.maps.Size(1, 1),
							isHidden: false,
							pane: "floatPane",
							enableEventPropagation: true
						};

						// create InfoBox
							//var infoBox = new InfoBox(infoBoxOptions);

						// create a reference from infoBox to the Marker
							//marker.infoBox = infoBox ;

						// close infoBox on map click
							google.maps.event.addListener(map, 'click', function() {
								//infoBox.close(); // if active => breaks the infoxbox-klick
							});

						// close infoBox on map drag
							google.maps.event.addListener(map, 'dragstart', function() {
								//infoBox.close();
							});
					}

			}

		/*
		*  centerMap
		*
		*  This function will center the map, showing all markers attached to this map
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	map (Google Map object)
		*  @return	n/a
		*/

			function centerMap(map, $el) {

				// vars
					var bounds = new google.maps.LatLngBounds();

				// loop through all markers and create bounds
					$.each( map.markers, function( i, marker ){

						var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

						bounds.extend(latlng);

					});

				// only 1 marker?
					if(map.markers.length === 1) {
						// set center of map
							map.setCenter(bounds.getCenter());
							map.setZoom(16);
					} else {
						// fit to bounds
							map.fitBounds(bounds);
					}

			}

		/*
		*  renderMap
		*
		*  This function will render a Google Map onto the selected jQuery element
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	$el (jQuery element)
		*  @return	n/a
		*/

			function renderMap($el) {

				// var
					//console.log($el);
					var $markers = $el.parent().find('#maps-pins .fridge');
					var MY_MAPTYPE_ID = 'custom_style';

				// vars
					var args = {
						center 				: 	new google.maps.LatLng(0, 0),
						//scrollwheel 		: 	false,
						gestureHandling 	: 	'cooperative',
						mapTypeControlOptions: {
							mapTypeIds 		: 	[google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
						},
						mapTypeControl 		: 	false,
						mapTypeId 			: 	MY_MAPTYPE_ID,
						disableDefaultUI 	: 	true
					};

				// create map
					var map = new google.maps.Map($el[0], args);

				// style
					var styledMapOptions = {
						name: 'Custom Style'
					};

					var featureOpts = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#000000"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}] ;					

					var customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);

					map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

				// add a markers reference
					map.markers = [];

				// add markers
					$markers.each(function(){

						addMarker($(this), map);

					});

				// center map
					centerMap(map, $el);

				// on map click
					map.addListener('click', function(e) {
						setTimeout(function() { // wir müssen kurz abwarten, bis die anderen events getriggert sind
							if($('#fridge-detail').hasClass('d-none') && currentInfoBox !== false) {
								currentInfoBox.close();
							}
						},33);
					});


				// on dragend => save center
					google.maps.event.addListener(map, 'dragend', function () {
						$el.data('map-center', map.getCenter());
					});

				// on zoom_changed => save zoom, and center
					google.maps.event.addListener(map, 'zoom_changed', function () {
						$el.data('map-zoom', map.getZoom());
						$el.data('map-center', map.getCenter());
					});


				// setCenter on Window Resize
					var resizeTimerMaps; // Set resizeTimer to empty so it resets on page load
					window.addEventListener('resize', function() {

						// warten bis die Tiles neu positioniert sind, als flex-horizontal / flex-vertical gesetzt ist
						clearTimeout(resizeTimerMaps);
						resizeTimerMaps = setTimeout(function() {

							google.maps.event.trigger(map, 'resize');
							map.setCenter($el.data('map-center'));
							map.setZoom($el.data('map-zoom'));

						}, 265);

					});

				// save init zoom
					var initIdleListener = google.maps.event.addListener(map, "idle", function() {

						// set zoom = 2 if zoom is smaller than 2
							if(map.getZoom() < 2) {
								map.setZoom(2);
							}

						// save_center and zoom
							$el.data('map-center', map.getCenter());
							$el.data('map-zoom', map.getZoom());

						// removeListener
							google.maps.event.removeListener(initIdleListener);

					});

				// redraw on pagelink klick
					$('body').on('click', '.pagelink', function() {
						google.maps.event.trigger(map, 'resize');
						map.setCenter($el.data('map-center'));
						map.setZoom($el.data('map-zoom'));
					});

			}



		/* initAndCenterMaps */

			function initAndCenterMaps() {

				$('.google-map').not('.first-init-done').each(function() {

					$(this).addClass('first-init-done');

					renderMap($(this));

				});
				
			}
			
		/* initAndCenterMaps */

	/* google maps */



	/* addUnderlineToH1 */

		function addUnderlineToH1() {

			$('h1.underline').each(function() {
				if($(this).find('i').length === 0) {
					var $newDomI = $('<i></i>');
					$newDomI
						.addClass('disappeared')
						.addClass('dotransition')
						//.data('appear-top-offset', '-600')
						;
					$(this).append($newDomI);
				}

			});

			setCorrectUnderlineDimensionsAndPositionAndPosition();

		}

	/* addUnderlineToH1 */



	/* setCorrectUnderlineDimensionsAndPositionAndPosition */

		function setCorrectUnderlineDimensionsAndPositionAndPosition() {

			var underlineOrigWidth 		= 	512 ;
			var underlineOrigHeight 	= 	48 ;

			switch(layoutIs) {
				case 'xs':
					underlineOrigHeight 	= 	24 ;
					break;
				case 'sm':
				case 'md':
					underlineOrigHeight 	= 	36 ;
					break;
				default:
					underlineOrigHeight 	= 	48 ;
					break;
			}

			var underlineMaxWidth ;
			var underlineWidth ;
			var underlineMarginLeft ;

			$('h1.underline').each(function() {

				$i = $(this).find('i');

				var underlineMaxWidth = $(this).width();

				// calculate underlineWidth
					underlineWidth = underlineOrigWidth ;
					if(underlineOrigWidth > underlineMaxWidth) {
						underlineWidth = underlineMaxWidth ;
					}

				// calculate
					//underlineMarginLeft = underlineMaxWidth - underlineWidth + (underlineWidth / 5) ;
					underlineMarginLeft = underlineMaxWidth - underlineWidth + (underlineWidth / 8) ;

				// set all the stuff
					$i
						.css('width', underlineWidth)
						.css('height', underlineOrigHeight)
						.css('background-size', underlineWidth + 'px ' + underlineOrigHeight + 'px')
						.css('margin-left', underlineMarginLeft)
						;

			});

		}

	/* setCorrectUnderlineDimensionsAndPositionAndPosition */



	/* fixSectionsWichAreHigherThan100vh */

		function fixSectionsWichAreHigherThan100vh() {

			$('body section').each(function() {

				$section 	= 	$(this);
				$container 	= 	$section.find('div.container, div.container-fluid');

				// reset section height
					$section.css('height','');

				// check if container is higher
					if(parseInt($container.outerHeight(true)) > parseInt($section.outerHeight(true))) {
						$section.css('height', $container.outerHeight(true));
					}
			});

		}

	/* fixSectionsWichAreHigherThan100vh */



	/* setH1TopPadding */

		function setH1TopPadding() {

			return ;

			$('section h1, section.video .embed-container').each(function() {

				$h1 		= 	$(this);
				$section 	= 	$h1.closest('section');
				$container 	= 	$section.find('div.container, div.container-fluid');
				console.log($(this), 'container.length => ', $container.length);

				// case graphics-slider
					if($section.hasClass('graphics-slider')) {

						// prepare var
							var h1WrapperMarginTop = 0 ;

						// check if container is higher
							if(
								(parseInt($h1.parent().outerHeight(true)) + 25) < parseInt($section.outerHeight(true))
								&&
								layoutIs !== "xs"
								&&
								layoutIs !== "sm"
							) {
								h1WrapperMarginTop = ((parseInt($section.outerHeight(true)) + 25) - parseInt($h1.parent().outerHeight(true))) / 3 ;
							}

						// set container margin top
							$h1.parent().css('margin-top', h1WrapperMarginTop);

					}

				// case slider-content-section
					if($section.hasClass('slider-content-section')) {

						// prepare var
							var h1WrapperMarginTop = 0 ;

						// check if container is higher
							if(
								parseInt($h1.outerHeight(true)) < parseInt($section.outerHeight(true))
								&&
								layoutIs !== "xs"
								&&
								layoutIs !== "sm"
							) {
								if($h1.parent().hasClass('content')) {
									h1WrapperMarginTop = (parseInt($section.outerHeight(true)) - parseInt($h1.parent().outerHeight(true)));
									h1WrapperMarginTop = h1WrapperMarginTop * 0.775 ;
								} else {
									h1WrapperMarginTop = (parseInt($section.outerHeight(true)) - parseInt($h1.outerHeight(true)));
									h1WrapperMarginTop = h1WrapperMarginTop * 0.32 ;
								}
							}

						// set container margin top
							$h1.parent().css('margin-top', h1WrapperMarginTop);

					}

				// case fridge-detail
					if($h1.closest('.row').attr('id') === "fridge-detail") {

						// prepare var
							var h1WrapperMarginTop 	= 	0 ;
							var $contentWrapper 	= 	$h1.parent();

						// check if container is higher
							if(
								parseInt($contentWrapper.outerHeight(true)) < parseInt($section.outerHeight(true))
								&&
								layoutIs !== "xs"
								&&
								layoutIs !== "sm"
							) {
								h1WrapperMarginTop = (parseInt($section.outerHeight(true)) - parseInt($contentWrapper.outerHeight(true))) / 4 ;
							}

						// set container padding top
							$contentWrapper.parent().css('padding-top', h1WrapperMarginTop);

					}

				// case title-text
					if($section.hasClass('title-text')) {

						// prepare var
							var containerMarginTop = 0 ;

						// check if container is higher
							if(parseInt($container.outerHeight(true)) < parseInt($section.outerHeight(true))
								&&
								layoutIs !== "xs"
								&&
								layoutIs !== "sm"
							) {
								containerMarginTop = (parseInt($section.outerHeight(true)) - parseInt($container.outerHeight(true))) / 2 ;
							}
							console.log('title-text', $section, 'containerMarginTop', containerMarginTop);

						// set container padding top
							$container.css('padding-top', containerMarginTop);

					}

				// case video
					if($section.hasClass('video')) {
						
						// prepare var
							var containerMarginTop = 0 ;

						// check if container is higher
							if(parseInt($container.outerHeight(true)) < parseInt($section.outerHeight(true))
								&&
								layoutIs !== "xs"
								&&
								layoutIs !== "sm"
							) {
								containerMarginTop = (parseInt($section.outerHeight(true)) - parseInt($container.outerHeight(true))) / 2 ;
							}

						// set container padding top
							$container.css('padding-top', containerMarginTop);

					}
			});

		}

	/* setH1TopPadding */



	/* setStepCardsSpacing */

		function setStepCardsSpacing() {

			$('section.step-cards').each(function() {

				return ;

				$section 	= 	$(this);
				$container 	= 	$(this).find('> .container');
				$row 		= 	$container.find('> .row');

				var wrapperTotalSpace = 0 ;
				var wrapperTopSpace = 0 ;
				var wrapperBottomSpace = 0 ;
				
				if(layoutIs !== "xs" && layoutIs !== "sm") {

					var rowOuterHeight = parseInt($row.outerHeight(true));
					var sectionOuterHeight = parseInt($section.outerHeight(true));
					console.log('rowOuterHeight', rowOuterHeight);
					console.log('sectionOuterHeight', sectionOuterHeight);

					// check if container is smaller than section
					if(rowOuterHeight < sectionOuterHeight) {
						wrapperTotalSpace = parseInt(sectionOuterHeight - rowOuterHeight) ;
						wrapperTopSpace = parseInt(wrapperTotalSpace / 7 * 4) ;
						wrapperBottomSpace = parseInt(wrapperTotalSpace / 7 * 3) ;
						console.log('wrapperTotalSpace', wrapperTotalSpace);
						console.log('wrapperTopSpace', wrapperTopSpace);
						console.log('wrapperBottomSpace', wrapperBottomSpace);
					}

				}

				$container
					.css('padding-top', wrapperTopSpace)
					.css('padding-bottom', wrapperBottomSpace)
					;

			});

		}

	/* setStepCardsSpacing */



	/* advancedLinkHandler */

		function advancedLinkHandler(e, $clickedLinkElement) {

			// windowLocationURL
				var windowLocationURL 	= 	new URL(window.location);

			// clickedHref
				var clickedHref 		= 	$clickedLinkElement.attr('href').toLowerCase();

				// make clickedHref to a valid href, if its not
					if(is.not.url(clickedHref) && clickedHref.substring(0,1) === "#") {
						clickedHref 		= 	windowLocationURL.origin + windowLocationURL.pathname + clickedHref.substring(0) ;
					} else if(is.not.url(clickedHref) && clickedHref.substring(0,2) === "/#") {
						clickedHref 		= 	windowLocationURL.origin + windowLocationURL.pathname + clickedHref.substring(1) ;
					}

			// clickedURL
				var clickedURL 			= 	new URL(clickedHref);

			// hash to lower case
				windowLocationURL.hash 	= 	windowLocationURL.hash.toLowerCase();
				clickedURL.hash 		= 	clickedURL.hash.toLowerCase();

			// is link same page as actual page AND NOT OPEN IN BLANK PAGE

				if(
					(windowLocationURL.origin + windowLocationURL.pathname) === (clickedURL.origin + clickedURL.pathname)
					&&
					(!$clickedLinkElement.attr('target') || $clickedLinkElement.attr('target') !== "_blank")
				) {

					// den hash gibts auf der seite
						if($('#section-' + clickedURL.hash.substring(1)).length > 0) {

							e.preventDefault() ;

							// bodyScrollLock => off
								//bodyScrollLock('off');

							// scrollToSection
								scrollToSection($('#section-' + clickedURL.hash.substring(1)));/*

					// tabs
						} else if($clickedLinkElement.hasClass('open-detail')) {
							
							e.preventDefault() ;

							openArticleDetails(e, $clickedLinkElement);*/

					// es ist die selbe Seite => Home => ScrollTop
						} else if(clickedURL.hash.substring(1) === "") {

							e.preventDefault() ;

							// scrollTop
								$('html,body,main').animate({scrollTop:(
									0
								)}, scrollTimeDefault, 'easeInOutCubic');

						}

					// closeMenu if its a link in the menu

						if($clickedLinkElement.parents('#menu-main').length === 1 ) { 
							if($clickedLinkElement.parent().hasClass('menu-item-has-children')) {
								// this is the submenu toggle
							} else {
								hideNavi() ;
							}
						}

					// closeMenu if its a link in the menu

					return ;

				}

			// ELSE differen page

		}

	/* advancedLinkHandler */



	/* isHashSetThenToScrollToAnchor */

		function isHashSetThenToScrollToAnchor() {

			var windowLocationURL 	= 	new URL(window.location);
			windowLocationURL.hash 	= 	windowLocationURL.hash.toLowerCase();

			if($('#section-' + windowLocationURL.hash.substring(1)).length > 0) {

				// clear hash in url
					history.pushState("", document.title, window.location.pathname);


				// wait a bit
					setTimeout(function(){

						// scrollToSection
							scrollToSection($('#section-' + windowLocationURL.hash.substring(1)).closest('section'));
							setTimeout(function(){
								scrollToSection($('#section-' + windowLocationURL.hash.substring(1)).closest('section'));
							}, scrollTimeDefault);

					}, 333);

			}

		}

	/* isHashSetThenToScrollToAnchor */



	/* maybeSetTargetLinks */

		function maybeSetTargetLinks() {
			$('a').each(function() {
				var $link = $(this);
				if (!$link.attr('href')) {
					console.warn('Link has no href:', $link);
					return;
				}
				var href = $link.attr('href').toLowerCase();
				var target = $link.attr('target');
				var isInternal = is.not.url(href) || (href.indexOf(window.location.origin) !== -1);
				var isPDF = href.indexOf('.pdf') !== -1;
				if (target === "_blank" || (isInternal && !isPDF)) {
					return;
				}
				$link.attr('target', '_blank');
			});
		}

	/* maybeSetTargetLinks */



	/* hideNavi */

		function hideNavi() {

			//var $hamburger = $('.hamburger');

			$('#menu-main').collapse('hide');
			//$hamburger.removeClass('is-active');

		}

	/* hideNavi */



	/* scrollToSection */

		function scrollToSection($section) {

			var topOffset = 0 ;

			topOffset 	= 	$section.offset().top ;
			
			/*console.log('yep');
			console.log('section-offset-top', $section.offset().top);
			console.log('main-offset-top', $('main').offset().top);*/

			//topOffset += windowScrollTop ;
			topOffset += 0 ;

			// IS NOT First-Section => Handle Height Of NaviBar
				/*if(!$section.hasClass('first-section')) {
					topOffset 	-= 	getHeightOfFixedNaviBar() ;
				}*/

			//topOffset += getTopOffsetFixValue();
			topOffset += 0 ;

			// scrollTop
				$('html,body,main').animate({scrollTop:(
					topOffset
				)}, scrollTimeDefault, 'easeInOutCubic');
				/*$('main').animate({scrollTop:(
					topOffset
				)}, scrollTimeDefault, 'easeInOutCubic');*/

		}

	/* scrollToSection */



	/* showFridgeDetails */

		function showFridgeDetails(fridgeIDSTR) {

            const fridgeID = fridgeIDSTR.split("-")[1];

            $('#fridge-detail .fridge-detail-content').hide();
            $('#fridge-detail .content-wrapper .fridge-detail-interchangeable').html('');
            $('#fridge-detail .content-wrapper #fridge-detail-address').attr('href', '');
            $('#fridge-detail > div').first().html('');
            
            // prepare data
				var data = {
					'lang': 	$('html')[0].lang.substring(0,2),
					'action': 	'ajax_post_data',
                    'dti':      'loadfridge',
					'c': 		fridgeID,
				};

            $.post($('body').data('admin_url'), data, function(response) {
                
             //       $('#fridge-detail .content-wrapper').html(response.content);
                    $('#fridge-detail .content-wrapper #fridge-detail-title').html(response.title);
                    $('#fridge-detail .content-wrapper #fridge-detail-address').html(response.addressdisplay);
                    $('#fridge-detail .content-wrapper #fridge-detail-address').attr('href', response.addresslink);
                    $('#fridge-detail .content-wrapper #fridge-detail-operator').html(response.operator);
					console.log(response.notesdescription);
					if ((typeof response.notesdescription === 'string' || response.notesdescription instanceof String) && response.notesdescription.length > 0) {
	                    $('#fridge-detail .content-wrapper #fridge-detail-notes-description').html(response.notesdescription);
						$('#fridge-detail .content-wrapper #fridge-detail-notes-description').parent().removeClass('d-none');
					} else {
						$('#fridge-detail .content-wrapper #fridge-detail-notes-description').parent().addClass('d-none');
					}
                    $('#fridge-detail .content-wrapper #fridge-detail-links-list').html(response.links);
                    $('#fridge-detail > div').first().html(response.image);
                    
                    $('#fridge-detail .fridge-detail-content').show();

				}, 'json');
            
            
//			$('#fridge-detail .content-wrapper').html($('#' + fridgeId + ' .fridge-detail-content').html());

//			$('#fridge-detail > div').first().html($('#' + fridgeId + ' .fridge-picture').html());

			$('#fridge-detail').removeClass('d-none');

			$('body').addClass('fridge-detail-open');

	/*		$('html,body,main').animate({scrollTop:(
				0
			)}, 0, 'easeInOutCubic'); */

			// add the fridge id to the url as a query parameter if it's not yet set
			const url = new URL(window.location.href);
			if (!url.searchParams.has('fridge')) {
				url.searchParams.set('fridge', fridgeIDSTR);
				window.history.pushState({}, '', url);
			}

			setH1TopPadding();
			setStepCardsSpacing();
            setTimeout(function() {
                addUnderlineToH1();
                $('#fridge-detail .content-wrapper h1 i').removeClass('disappeared');
			}, 1111);

			setTimeout(function() {
				$('#fridge-detail .content-wrapper h1 i').removeClass('dotransition');
			}, 2111);

		}

	/* showFridgeDetails */



	/* graphics carousel */

		/* calculateSectors */

			function calculateSectors() {

				$('.graphics-slider .graphics-carousel .carousel-cell').each(function() {
					writeSectorInSlide($(this), false);
				});

			}

		/* calculateSectors */

		/* writeUpSectorInSlide */

			function writeUpSectorInSlide($slide, writePercentage, stopByPercentage) {

				writeSectorInSlide($slide, writePercentage);

				if(writePercentage < stopByPercentage) {
					writePercentage++ ;
					setTimeout(function() {
						writeUpSectorInSlide($slide, writePercentage, stopByPercentage);
					}, 25 * ((100 - (1.5 * writePercentage)) / 100));
				} else {
					$slide.find('span').removeClass('concealed');
				}

			}

		/* writeUpSectorInSlide */

		/* writeSectorInSlide */

			function writeSectorInSlide($slide, percentageOverwrite) {

				//https://danielpataki.com/svg-pie-chart-javascript/

				var percentage = $slide.data('percentage') / 100 ;

				if(percentageOverwrite !== false) {
					percentage = percentageOverwrite / 100 ;
				}

				var sector ;

				var size = $slide.width() * 0.66 ;

				var l = size / 2
				var a = 0 // Angle
				var aRad = 0 // Angle in Rad
				var z = 0 // Size z
				var x = 0 // Side x
				var y = 0 // Side y
				var X = 0 // SVG X coordinate
				var Y = 0 // SVG Y coordinate
				var R = 0 // Rotation

				a = 360 * percentage;
				aCalc = ( a > 180 ) ? 360 - a : a;
				aRad = aCalc * Math.PI / 180;
				z = Math.sqrt( 2*l*l - ( 2*l*l*Math.cos(aRad) ) );
				if(aCalc <= 90) {
					x = l*Math.sin(aRad);
				} else {
					x = l*Math.sin((180 - aCalc) * Math.PI/180 );
				}

				y = Math.sqrt( z*z - x*x );
				Y = y;

				if(a <= 180) {
					X = l + x;
					arcSweep = 0;
				} else {
					X = l - x;
					arcSweep = 1;
				}

				sector = {
					percentage: percentage,
					color: '#FF0000',
					arcSweep: arcSweep,
					L: l,
					X: X,
					Y: Y,
					R: R
				};

				$slide.find('svg circle')
					.attr('cx', size / 2)
					.attr('cy', size / 2)
					.attr('r', size / 2 * 0.9)
					;

				$slide.find('svg path')
					.attr('d', 'M' + sector.L + ',' + sector.L + ' L' + sector.L + ',0 A' + sector.L + ',' + sector.L + ' 1 ' + arcSweep + ',1 ' + sector.X + ', ' + sector.Y + ' z')
					.attr('transform', 'rotate(' + sector.R + ', '+ sector.L+', '+ sector.L+')')
					;

				$slide.find('svg')
					.css('width', size + 'px')
					.css('height', size + 'px')
					.css('margin-left', ($slide.width() - size) / 2)
					.css('margin-top', ($slide.height() - size) / 2)
					;

				if(parseInt($slide.data('percentage')) > 0) {
					$slide.find('span')
						.css('margin-top', ($slide.height() - size) / 2)
						;
				} else {
					$slide.find('span')
						.css('margin-top', ($slide.height() - $slide.find('span').height()) / 2 * 0.975);
						;
				}

				return sector ;

			}

		/* writeSectorInSlide */

	/* graphics carousel */



	/* flickityInit */

		function flickityInit() {

			var slidersFlickityOptions = {
				pageDots: false,
				prevNextButtons: false,
				imagesLoaded: true,
				// wrapAround: true,
				//setGallerySize: true,
				freeScroll: false,
				cellAlign: 'center',
				contain: true,
				draggable: false,
				pauseAutoPlayOnHover: false,
				autoPlay: 2222
			} ;

			var teamCarouselFlickityOptions = {
				pageDots: false,
				prevNextButtons: false,
				imagesLoaded: true,
				wrapAround: true,
				//setGallerySize: true,
				freeScroll: false,
				cellAlign: 'left',
				contain: true,
				draggable: true,
				pauseAutoPlayOnHover: true,
				autoPlay: 2222
			} ;

			var $headerCarousel 				= 	$('.header-carousel');
			var $headerCarouselCarousel 		= 	$headerCarousel.flickity(slidersFlickityOptions);

			var $defaultCarousel 				= 	$('.default-carousel');
			var $defaultCarouselCarousel 		= 	$defaultCarousel.flickity(slidersFlickityOptions);

			var testimonialsCarouselFlickityOptions = {
				//asNavFor: '.graphics-carousel',
				pageDots: true,
				prevNextButtons: false,
				imagesLoaded: false,
				// wrapAround: true,
				//setGallerySize: true,
				freeScroll: false,
				cellAlign: 'center',
				contain: true,
				draggable: false,
				pauseAutoPlayOnHover: false,
				selectedAttraction: 1,
				friction: 1/*,
				autoPlay: 3333*/
			} ;
			var $testimonialsCarousel 			= 	$('.testimonials-carousel');
			var $testimonialsCarouselCarousel 	= 	$testimonialsCarousel.flickity(testimonialsCarouselFlickityOptions);

			var $teamCarousel 					= 	$('.team-carousel');
			var $teamCarouselCarousel 			= 	$teamCarousel.flickity(teamCarouselFlickityOptions);

			$('.graphics-slider, .slider-with-title-text-and-graphic').each(function() {

				var graphicsSliderFlickityOptions = {
					asNavFor: '#' + $(this).attr('id') + ' .graphics-nav-carousel',
					pageDots: false,
					prevNextButtons: false,
					imagesLoaded: true,
					// wrapAround: true,
					//setGallerySize: true,
					freeScroll: false,
					cellAlign: 'center',
					contain: true,
					draggable: false,
					pauseAutoPlayOnHover: false,
					selectedAttraction: 1,
					friction: 1/*,
					autoPlay: 3333*/
				} ;

				var graphicsNavSliderFlickityOptions = {
					//asNavFor: '.graphics-carousel',
					pageDots: true,
					prevNextButtons: false,
					imagesLoaded: false,
					// wrapAround: true,
					//setGallerySize: true,
					freeScroll: false,
					cellAlign: 'center',
					contain: true,
					draggable: false,
					pauseAutoPlayOnHover: false,
					selectedAttraction: 1,
					friction: 1/*,
					autoPlay: 3333*/
				} ;

				var $graphicsCarousel 				= 	$('#' + $(this).attr('id') + ' .graphics-carousel');
				var $graphicsCarouselCarousel 		= 	$graphicsCarousel.flickity(graphicsSliderFlickityOptions);

				var $graphicsNavCarousel 			= 	$('#' + $(this).attr('id') + ' .graphics-nav-carousel');
				if($(this).hasClass('slider-with-title-text-and-graphic')) {
					$graphicsNavCarousel.on('ready.flickity', function() {
						$graphicsNavCarousel.find('.flickity-page-dots li').each(function(index) {
							var clonedSvgHtmlForDot = '';
							if($graphicsCarousel.find('.carousel-cell:nth-child(' + (index + 1) + ') svg').length > 0) {
								clonedSvgHtmlForDot = $graphicsCarousel.find('.carousel-cell:nth-child(' + (index + 1) + ') svg').first()[0].outerHTML;
							}
							$(this).html(clonedSvgHtmlForDot);
						});
						$graphicsNavCarousel.find('.flickity-page-dots li svg').on('click', function() {
							$(this).parent().click();
						});
					});
				}
				var $graphicsNavCarouselCarousel 	= 	$graphicsNavCarousel.flickity(graphicsNavSliderFlickityOptions);

				if($(this).hasClass('graphics-slider')) {
					$graphicsNavCarouselCarousel.on('settle.flickity', function(event, index) {
						writeUpSectorInSlide($graphicsCarousel.find('.carousel-cell.is-selected'), 0, $graphicsCarousel.find('.carousel-cell.is-selected').data('percentage'));
					});

					$graphicsNavCarouselCarousel.on('change.flickity', function(event, index) {
						$graphicsCarousel.find('.carousel-cell.is-selected span').addClass('concealed');
						writeSectorInSlide($graphicsCarousel.find('.carousel-cell.is-selected'), 0);
					});
				}

			});

		}

	/* flickityInit */
	
	/* setSomeImportantClasses */

		function setSomeImportantClasses() {

			/*if(is.mobile()) {
				$('body').addClass('is--mobile');
			}*/

			if(is.touchDevice()) {
				$('body').addClass('is--touchDevice');
			}

			if(is.ie()) {
				$('body').addClass('is--browser-is-ie');
				imgFitCoverPoly();
			}

			if(is.edge()) {
				$('body').addClass('is--browser-is-edge');
			}

			/*if(is.chrome()) {
				$('body').addClass('is--browser-is-chrome');
			}

			if(is.firefox()) {
				$('body').addClass('is--browser-is-firefox');
			}

			if(is.opera()) {
				$('body').addClass('is--browser-is-opera');
			}

			if(is.safari()) {
				$('body').addClass('is--browser-is-safari');
			}

			if(is.windows()) {
				$('body').addClass('is--os-is-windows');
			}

			if(is.iphone()) {
				$('body').addClass('is--device-is-iphone');
			}*/

			$('body').addClass('is--is-set');

		}

	/* setSomeImportantClasses */



	/* imgFitCoverPoly */

	function imgFitCoverPoly() {

		if(is.ie()) {

			$('img.img-fit-cover').each(function() {

				var $thisImage 	= 	$(this) ;
				var $wrapper 	= 	$thisImage.closest('div') ;

				var sizeOfWrapper = { width : parseInt($wrapper.width()), height : parseInt($wrapper.height()) } ;


				sizeOfCurrentSource = { width : $(this).data('uploaded-file-width'), height : $(this).data('uploaded-file-height') };

					// höhe ist massgebend');
						if(
							sizeOfWrapper.height
							>
							(sizeOfCurrentSource.height / sizeOfCurrentSource.width * sizeOfWrapper.width)
						) {

							var calculatedWidth 	= 	sizeOfCurrentSource.width / sizeOfCurrentSource.height * sizeOfWrapper.height ;
							var marginLeft 			= 	(sizeOfWrapper.width - calculatedWidth) / 2
							var marginTop 			= 	0

							$thisImage
								.css('width', calculatedWidth)
								.css('height', sizeOfWrapper.height)
								.css('margin-left', marginLeft)
								.css('margin-top', marginTop)
								.css
								;

					// breite ist massgebend
						} else {

							var calculatedHeight 	= 	sizeOfCurrentSource.height / sizeOfCurrentSource.width * sizeOfWrapper.width ;
							var marginLeft 			= 	0 ;
							var marginTop 			= 	(sizeOfWrapper.height - calculatedHeight) / 2 ;

							$thisImage
								.css('width', sizeOfWrapper.width)
								.css('height', calculatedHeight)
								.css('margin-left', marginLeft)
								.css('margin-top', marginTop)
								;
						}

			});

		}

	}

	/* imgFitCoverPoly */



	/* resizeFunction */

		function resizeFunction() {

			if(windowWidthForResize !== $(window).width()) {

				// update var
					windowWidthForResize = $(window).width() ;

			}

			// getLayout
				getLayout(true) ;

			// setCorrectUnderlineDimensionsAndPositionAndPosition
				setCorrectUnderlineDimensionsAndPositionAndPosition();

			// setH1TopPadding
				setH1TopPadding();
				setStepCardsSpacing();

			// fixSectionsWichAreHigherThan100vh
				fixSectionsWichAreHigherThan100vh();

			// calculateSectors
				calculateSectors();


		}
	
	/* resizeFunction */



	/* initFunction */

		function initFunction() {

			// is.ie || is.edge
				//if(is.ie() || is.edge() || true) {
				/*if(is.ie() || is.edge()) {
					//$('.img-cover').addClass('img-cover-js');
				}
				if(is.ie(11)) {
					$('body').addClass('is-ie-11');
				}*/


			// getLayout
				getLayout(true) ;

			// addUnderlineToH1
				addUnderlineToH1();

			// setH1TopPadding
				setH1TopPadding();
				setStepCardsSpacing();

			// fixSectionsWichAreHigherThan100vh
				fixSectionsWichAreHigherThan100vh();
			
			// setSomeImportantClasses
				setSomeImportantClasses();

			// maybeSetTargetLinks
				maybeSetTargetLinks();

			// imgFitCoverPoly
				imgFitCoverPoly() ;

			// $.force_appear()
				$.force_appear();

			// initAndCenterMaps
				//initAndCenterMaps();

			// calculateSectors
				calculateSectors();

			// isHashSetThenToScrollToAnchor
				isHashSetThenToScrollToAnchor() ;


		}

	/* initFunction */



	(function($){

		$(document).ready(function() {

			$(function() {

				/* menu-item-object-custom click */

					$('a').on('click', function(e) {

						advancedLinkHandler(e, $(this)) ;

					});

				/* menu-item-object-custom click */

				// On resize, run the function and reset the timeout
				// 250 is the delay in milliseconds. Change as you see fit.

				$(window).resize(function() {

					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(resizeFunction, 250);

				});
				function orientationChanged() {

					resizeFunction() ;

				}

				flickityInit() ;

				/* google-maps-info-box .circle click */

				// check if the fridge parameter is set
				const url = new URL(window.location.href);
				if (url.searchParams.has('fridge')) {
					var fridgeId = url.searchParams.get('fridge');
					showFridgeDetails(fridgeId);
				}

					$('body').on('click', '.google-maps-info-box .circle, .google-maps-info-box .circle p', function(e) {

						var $this = $(this);

						// if its the <p>, get the parent
							if(!$this.hasClass('circle')) {
								$this = $this.parent();
							}

						var fridgeId = $this.data('fridge-id');

						showFridgeDetails(fridgeId);

					});

				/* google-maps-info-box .circle click */

				/* locations-list click */

					$('body').on('click', '.locations-list a, .place-infos-button button', function(e) {

						e.preventDefault() ;

						console.log('click on locations-list a or place-infos-button button', e.target);
						
						showFridgeDetails($(this).closest('div').data('fridge-id'));

					});

				/* locations-list click */

				/* google-maps-info-box close */

					$('body').on('click', '#fridge-detail .hamburger', function() {
						$('#fridge-detail').addClass('d-none');
						$('body').removeClass('fridge-detail-open');

						// remove the fridge id from the url
						const url = new URL(window.location.href);
						url.searchParams.delete('fridge');
						window.history.pushState({}, '', url);
					});

				/* google-maps-info-box close */



				/* pop-up-video */

					if($('#popup-overlay').length > 0) {

						var popUpVideoCookieLifetimeInDays 	= 	$('#pop-up-video').data('cookie_lifetime_in_days');
						var popUpVideoCookieId 				= 	$('#pop-up-video').data('cookie_id');

						if(Cookies.get(popUpVideoCookieId) === undefined) {
							window.setTimeout(function() {
								$('#popup-overlay').fadeIn();
							}, 500);
						}

						$('#popup-overlay').on('click', function() {
							$('#popup-overlay').fadeOut();
							Cookies.set(popUpVideoCookieId, 'set', { expires: popUpVideoCookieLifetimeInDays });
						});

					}

				/* pop-up-video */


				window.addEventListener('orientationchange', orientationChanged);

				initFunction();




			});

		});



			/* appear */

				// appear init
					$('h1.underline').appear();

				// on default (appear on scroll)
					//$('main').on('appear', 'section', function(e, $affected) {
					$('body').on('appear', 'h1.underline', function(event, $all_disappeared_elements) {

						$i = $(this).find('i') ;
						
						if($i.hasClass('disappeared')) {
							$i.removeClass('disappeared');
							setTimeout(function() {
								$i.removeClass('dotransition');
							}, 999);
						}

					});

			/* appear */



			/* scroll on news page */

				if($('body').hasClass('page-template-news')) {
					
					currentCategory = $('news-container').data('current-category');
					allLoaded = false;

					$(window).on('scroll', function() {
					//	console.log("triggered by scroll");
						loadNews(currentCategory);
					});

				}
				
				

			/* scroll on news page */



			/* detect menu collapse */

				$('#menu-main')
					.on('show.bs.collapse', function () {
						$('body').addClass('menu-is-open');
					})
					.on('hide.bs.collapse', function () {
						$('body').removeClass('menu-is-open');
					});

			/* detect menu collapse */



			/* submenu toggle */

				$('.menu-item-has-children > a').on('click', function(e) {
					if(!is.touchDevice()) {
						return;
					}
					//console.log('submenu toggle', 'is touch device')
					if($(this).attr('href') == "#") {
						e.preventDefault() ;
						$(this).parent().toggleClass('show-sub-menu');
					}
				});

			/* submenu toggle */

	})(jQuery);

	window.onload = function () {

		initFunction();
		setTimeout(initFunction, 250);

	} ;
	
	
	function loadNews(termID = 0) {

		if(allLoaded) {
			return ;
		}

		$newsContainer 			= 	$('.news-container');
		if ($newsContainer.find('h2').length > 0){
			$lastH2InNewsContainer 	= 	$newsContainer.find('h2').last();
		} else {
			$lastH2InNewsContainer	=	$newsContainer;
		}

		postsPerPage 			= 	parseInt($newsContainer.data('posts-per-page'));
		pageNumber 				= 	parseInt($newsContainer.data('page-number'));

		if(
			$('.load-more').hasClass('d-none')
			&&
			(
				$lastH2InNewsContainer.position().top < $(window).height()
				||
				$lastH2InNewsContainer.position().top < ($(document).scrollTop() + $(window).height())
			)
		) {

			// pageNumber + 1
				pageNumber++ ;
				$newsContainer.data('page-number', pageNumber);

			$('.load-more').removeClass('d-none');

			// prepare data
				var data = {
					'action': 	'ajax_post_data',
					'dti': 		'loadnews',
					'ppp': 		postsPerPage,
					'pn': 		pageNumber,
					'c': 		termID,
					'lang': 	$('html').attr('lang').substring(0,2),
				};

			// send
				$.post($('body').data('admin_url'), data, function(response) {

					$('.load-more').addClass('d-none');
					if(response.result === true && response.posts.length > 0) {

						// write posts
							$.each(response.posts, function(i, post) {
								postContentInner = post.thumbnail +
											'<div class="title">' +
												'<h2>' + post.title + '</h2>' +
											'</div>';
									postContent = '<div class="news-tile" category="' + post.categories + '" data-header_date_month="' + post.date_month + '" data-header_date_year="' + post.date_year + '">' +
											'<a href="' + post.url + '" title="' + post.title + '" target="_blank">' +
												postContentInner +
											'</a>' +
										'</div>';
								$newsContainer.append(postContent);
							});
						
						// scroll 1 pixel to trigger scroll event
							window.scrollTo(window.scrollX, (window.scrollY + 1));

					} else {

						// do something else instead
							allLoaded = true;

					}

				}, 'json');

		}
		
	}


	/* scroll arrow */

	$(window).scroll( function(){
		scrollarrowVisibility();
		showHamburger();
	});

    $(document).ready( function(){
        setTimeout(function(){
            scrollarrowVisibility();
			showHamburger();
        }, 100);
	});

    function scrollarrowVisibility() {
        /* lastSectionPosition = $('section').last().position().top - $(document).scrollTop() - ($(window).height() / 2);
		if(lastSectionPosition < 0) {
			$('#scrollarrow').fadeOut();
		} else {
			$('#scrollarrow').fadeIn();
		} */
		var wpAdminBarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height'));
		if(isNaN(wpAdminBarHeight)) {
			wpAdminBarHeight = 0;
		}
		var footerHeight = parseInt($('body > footer').height());
		if(parseInt($(window).width()) < 992) {
			footerHeight = 0 ;
		}
		//console.log(parseInt($(window).height()), wpAdminBarHeight, footerHeight);
		if(parseInt($(document).scrollTop()) > (parseInt((parseInt($(window).height()) - wpAdminBarHeight - footerHeight) / 1) - 1)) {
			$('#scrollarrow').fadeOut();
		} else {
			$('#scrollarrow').fadeIn();
		}
    }

    function showHamburger() {
		if(parseInt($(document).scrollTop()) > 115) {
			$('body').addClass('show-hamburger');
		} else {
			$('body').removeClass('show-hamburger');
		}
    }

	function scrollToNextSection() {
		$sections = $('section');
		if($('body').hasClass('page-template-modular-content')) {
			$sections = $('main > header, main > div');
		}
		$sections.each(function(){
			position = $(this).position().top - $(document).scrollTop() - ($(window).height() / 2);
			if(position > 0) {
				var jump = $(this);
				var new_position_top = $(jump).offset().top;
				var wpAdminBarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height'));
				if(!isNaN(wpAdminBarHeight)) {
					new_position_top -= wpAdminBarHeight ;
				}
				$('html, body').stop().animate({ scrollTop: new_position_top }, 750, 'swing');
				return false;
			}
		});
	}
	window.scrollToNextSection = scrollToNextSection;

	/* scroll arrow */


	/* flipper */
	
	$('.flip-container').hover(
		function () {if ($(window).width() > 991){ $(this).addClass('active'); }},
		function () {if ($(window).width() > 991){ $(this).removeClass('active');}}
	);
	
	$(window).scroll( function(){
		if ($(window).width() <= 991){
			$('.flip-container').each(function(index){
				let position = $(this).offset().top - $(document).scrollTop() - ($(window).height() * 0.4);
				if(position < 0) {
					$(this).addClass('active');
				} else {
					$(this).removeClass('active');
				}
			});
		}
	});
	
	/* flipper */


	/* keep elements squared */
	
	function squareElement(){
		$('.squared').each(function () {
			$(this).outerHeight( $(this).outerWidth() );
			$(this).css('opacity', '1');
		});
	}
	
	$(window).on('load resize', function() {
		squareElement();
	} );
	
	/* keep elements squared */


	/* news filter */

	$(document).click(function(event){
		if(!$(event.target).closest('.news-filter').length){
			$('.news-filter > .content').hide();
		}
	});

	function toggleFilter() {
		$('.news-filter > .content').toggle();
	}
	window.toggleFilter = toggleFilter;

	function filterNews(termID) {
		
		$('.news-container').data('page-number', 0);
		$('.news-container').html('');
		$(window).on('scroll', function() {
			loadNews(termID);
		});
		allLoaded = false;
		
		$('.news-filter > .content').hide();
		
		currentCategory = termID;
		loadNews(currentCategory);

	}
	window.filterNews = filterNews;
	
	/* news filter */


	/* Presse, handleFirstVisible */

	const $news_container = document.querySelector('body.page-template-news .news-container');
	const $monthYearContainer = document.querySelector('body.page-template-news .fixed-header');
	let $monthYearContainer_year = null;
	let $monthYearContainer_month = null;
	if($monthYearContainer) {
		$monthYearContainer_year = $monthYearContainer.querySelector('.year');
		$monthYearContainer_month = $monthYearContainer.querySelector('.month');
		if ($news_container) {
			register_date_scroll_display($news_container, { offset_top: 0 });
		}
	}

	function handleFirstVisible($el) {
		$monthYearContainer_year.textContent = $el.dataset.header_date_year;
		$monthYearContainer_month.textContent = $el.dataset.header_date_month;
	}
	function isVisible(el, offset_top = 0) {
		const bb = el.getBoundingClientRect();
		return bb.top < window.innerHeight && bb.top > offset_top;
	}
	function register_date_scroll_display($container, {offset_top = 0}) {
		window.addEventListener('scroll', () => {
			let $first_visible = null;
			const $tiles = $container.querySelectorAll('.news-tile');
			$tiles.forEach($el => {
				if (isVisible($el, offset_top) && !$first_visible) {
					$first_visible = $el;
					handleFirstVisible($el);
				}
			});
		});
	}

	/* Presse, handleFirstVisible */
/* base64 decode encode  */

function base64code(string, direction) {

	// https://scotch.io/quick-tips/how-to-encode-and-decode-strings-with-base64-in-javascript
	
	// Create Base64 Object
		var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}

	// Encode the String
		if(direction === "encode") {
			return Base64.encode(string);
		}

	// Decode the String
		if(direction === "decode") {
			return Base64.decode(string);
		}

}

/* base64 decode encode  */



/* email-protection with data-flags */

// 1 - data('inner') NOT SET
	// rein: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" href="#">Irgendwas</a>
	// raus: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" href="mailto:user@domain.tld">Irgendwas</a>

// 2 - data('inner') SET = thisEmail
	// rein: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" data-inner="thisEmail" href="#">Irgendwas</a>
	// raus: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" data-inner="thisEmail" href="mailto:user@domain.tld">user@domain.tld</a>

// 3 - data('inner') SET = "Custom Text"
	// rein: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" data-inner="Say Hello" href="#">Irgendwas</a>
	// raus: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" data-inner="Say Hello" href="mailto:user@domain.tld">Say Hello</a>

		function deCryptProtectedLinks() {
			
			$('a.mailto').each(function() {

				var email = $(this).data('user') + '@' + $(this).data('domain') + '.' + $(this).data('tld') ;
				this.href = 'mailto:' + email;
				if($(this).data('inner') !== undefined) {
					if($(this).data('inner') === "thisEmail") {
						this.innerHTML = email;
					} else {
						this.innerHTML = $(this).data('inner');
					}
				}
			});

			$('a.tel').each(function() {
				var tel = base64code($(this).data('crypttel'), 'decode') ;
				this.href = 'tel:' + tel;
				if($(this).data('cryptinner') !== undefined) {
						this.innerHTML = base64code($(this).data('cryptinner'), 'decode');
				}
			});

		}

		(function($){

			deCryptProtectedLinks();

		})(jQuery);

/* email-protection with data-flags */



/* findBootstrapEnvironment */

/* bootstrap 4 */

function findBootstrapEnvironment() {

	var envsAndClasses = {
		xs : ["d-sm-none"],
		sm : ["d-none","d-sm-block","d-md-none","d-lg-none","d-xl-none"],
		md : ["d-none","d-md-block","d-lg-none","d-xl-none"],
		lg : ["d-none","d-lg-block","d-xl-none"],
		xl : ["d-none","d-xl-block"]
	} ;


	for(var env in envsAndClasses) {

		var el = $('<div>');
		el.appendTo($('body'));

		for(var classNameKey in envsAndClasses[env]) {

			el.addClass(envsAndClasses[env][classNameKey]);

		}

		if(el.is(':visible')) {

			el.remove();

			return env ;

		} else {

			el.remove();

		}

	}
	
}

/* findBootstrapEnvironment */



/* getLayout */

var layoutIs ;
function getLayout(forceCheck) {
	
	if(forceCheck || layoutIs === '') {
		layoutIs = findBootstrapEnvironment() ;
	}

	return layoutIs ;

}

/* getLayout */



/* fixModalBackDrop */

function fixModalBackDrop() {

	// iOS check...ugly but necessary
	if( navigator.userAgent.match(/iPhone|iPad|iPod/i) ) {
		setTimeout( function() {
			$('.modal-backdrop').css({
				position: 'absolute', 
				top: 0, 
				left: 0,
				width: '100%',
				height: Math.max(
					document.body.scrollHeight, document.documentElement.scrollHeight,
					document.body.offsetHeight, document.documentElement.offsetHeight,
					document.body.clientHeight, document.documentElement.clientHeight
				) + 'px'
			});
		}, 0);
	}
}

/* fixModalBackDrop */



/* cookie-message privacy-policy */

var privacyPolicy_cookieName 							= 	'cookie-message' ;
var privacyPolicy_cookieExpiresAfterNumber_OfDays 		= 	30 ;

var createLoadingCookie = function(name, value, days) {
	var expires;
	if(days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toGMTString();
	} else {
		expires = "";
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}

function getLoadingCookie(c_name) {
	if(document.cookie.length > 0) {
		c_start = document.cookie.indexOf(c_name + "=");
		if(c_start != -1) {
			c_start = c_start + c_name.length + 1;
			c_end = document.cookie.indexOf(";", c_start);
			if(c_end == -1) {
				c_end = document.cookie.length;
			}
			return unescape(document.cookie.substring(c_start, c_end));
		}
	}
	return false ;
}

/* cookie-message privacy-policy */

